var fowtr_module_navigation = (function (fowtr_module_navigation) {
    
    var menuHasOpened = false;

    // ===============================================================
    // sticky header
    // ===============================================================

    fowtr_module_navigation.stickyNavStuff = function(scrollTop){
      var $el = $('#fowtr-navigation');
      var ot = $('#fowtr-wrapper').offset().top - 1;

      // matching DHL trigger point
      // var header = $('header');
      // var message = $('.c-global-newsflash--wrapper');
      // var ot = message.height()+header.height();

      var headerHeight = 0;
      if($('header').length) headerHeight = $('header').height();
      var messageHeight = 0;
      if($('.c-global-newsflash--wrapper').length && $('.c-global-newsflash--wrapper').is(":visible")) messageHeight = $('.c-global-newsflash--wrapper').height();
      var ot = headerHeight+messageHeight;


      if (scrollTop > ot){
        $('#fowtr-navigation, #fowtr-navigation-panel, #fowtr-loading, #fowtr-read-aloud-playbar-wrapper').addClass('fixed-top');
      } else {
        $('#fowtr-navigation, #fowtr-navigation-panel, #fowtr-loading, #fowtr-read-aloud-playbar-wrapper').removeClass('fixed-top');
      }


      // hide the nav etc when scrolling past the content
      var bottom = $('#fowtr-wrapper').height();
        // console.log('scrollTop',scrollTop);
        // console.log('bottom',bottom);
      if (scrollTop > bottom){
        $('#fowtr-navigation, #fowtr-navigation-panel, #fowtr-read-aloud-playbar-wrapper').addClass('hidden');
      } else {
        $('#fowtr-navigation, #fowtr-navigation-panel, #fowtr-read-aloud-playbar-wrapper').removeClass('hidden');
      }


    };


    fowtr_module_navigation.init = function(chapter){

      // console.log('fowtr_module_navigation initialised for chapter ' + chapter);

      // ===============================================================
      // NAVIGATION
      // ===============================================================

      // open automatically
      // if(chapter==1 && menuHasOpened==false) {
      //   setTimeout(function(){
      //     $('#fowtr-navigation .fowtr-hamburger-menu').addClass('open');
      //     $('#fowtr-navigation-panel').addClass('open');
      //     menuHasOpened = true;
      //   },1000);
      // }

      // click handler to open and close
      $("#fowtr-navigation").on('click','.fowtr-hamburger-menu', function(e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $('#fowtr-navigation-panel').toggleClass('open');
      });

      // close when clicking something
      $("#fowtr-navigation-menu").on('click','a', function(e) {
        e.preventDefault();
        $('#fowtr-navigation .fowtr-hamburger-menu').removeClass('open');
        $('#fowtr-navigation-panel').removeClass('open');        
      });

      // handle sticky
      $(window).scroll(function(e){
        fowtr_module_navigation.stickyNavStuff($(this).scrollTop());
      });

      // function stickyNavStuff(scrollTop){
      //   var $el = $('#fowtr-navigation');
      //   var ot = $('#fowtr-wrapper').offset().top - 56;
      //   if (scrollTop > ot){
      //     $('#fowtr-navigation, #fowtr-navigation-panel, #fowtr-loading').addClass('fixed-top');
      //   } else {
      //     $('#fowtr-navigation, #fowtr-navigation-panel, #fowtr-loading').removeClass('fixed-top');
      //   }
      // }

      fowtr_module_navigation.stickyNavStuff($(window).scrollTop());



      // resize event to catch any shifting. debounced tho.
      var scrollEvent = fowtr_module_utilities.debounce(function(){
        fowtr_module_navigation.stickyNavStuff($(window).scrollTop());
      },500);
      window.onresize = scrollEvent;





      // ===============================================================
      // PILL MENU
      // ===============================================================

      // var pillNavContainer = $('#fowtr-pill-nav');
      // var mainNavContainer = $('#fowtr-navigation-menu');
      // //clear out first
      // pillNavContainer.html('');
      // mainNavContainer.html('');
      // var i = 0;
      // $('[fowtr-data-section-label]').each(function( index ) {
      //   var label = $(this).attr('fowtr-data-section-label');
      //   var id = $(this).attr('id');
      //   // console.log('label',label);
      //   var level = $(this).attr('fowtr-data-section-level');
      //   var levelClass = '';
      //   if (typeof level !== 'undefined' && level !== false && level !== '') {
      //     // console.log('level',level);
      //     levelClass = ' fowtr-anchor-level-'+level;
      //   }
      //   var pill = $('<a href="#'+id+'" class="fowtr-anchor'+i+levelClass+'"><span>'+label+'</span></a>');
      //   pill.appendTo(pillNavContainer);
      //   pill.clone().appendTo(mainNavContainer);
      //   new ScrollMagic.Scene({ triggerElement: '#' + id, duration: $('#' + id).height(), triggerHook: 'onCenter'})
      //       .setClassToggle('.fowtr-anchor'+i, 'active')
      //       .addTo(fowtr_module_scrollmagic.controller);
      //   i++;
      // });







      // function fitPillNav(scrollTop){
      //   var ot = $('#fowtr-wrapper').offset().top - 1;
      //   // console.log('fitting pillnav');
      //   var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      //   if (scrollTop > ot){
      //     // not at the top
      //     $('#fowtr-pill-nav-wrapper').addClass('fixed-top');
      //     // $('#fowtr-pill-nav-wrapper').css('height','100vh');

      //     var bottomGap = (windowHeight - (ot + $('#fowtr-wrapper').height())) + scrollTop;
      //     if(bottomGap>0){
      //       //past bottom of content
      //       $('#fowtr-pill-nav-wrapper').css('height',windowHeight - bottomGap + 'px');
      //     } else {
      //       //fill height so it's middle of page
      //       $('#fowtr-pill-nav-wrapper').css('height','100vh');
      //     }

      //   } else {
      //     // at the top
      //     $('#fowtr-pill-nav-wrapper').removeClass('fixed-top');
      //     var et = $('#fowtr-wrapper').offset().top;
      //     var loaderHeight = windowHeight - (et - scrollTop);
      //     // console.log('loaderHeight',loaderHeight);
      //     // console.log('et',et);
      //     $('#fowtr-pill-nav-wrapper').height(loaderHeight);
      //   }
      // }
      // $(window).scroll(function(e){
      //   fitPillNav($(this).scrollTop());
      // });
      // $(window).on('resize', function(){
      //   fitPillNav($(this).scrollTop());
      // });

      // fitPillNav($(window).scrollTop());








      // if(chapter==1){
      //   scenes = {
      //     'Introduction': {
      //       'fowtr-section1': 'fowtr-anchor1'
      //     },
      //     'Macroforces': {
      //       'fowtr-section2': 'fowtr-anchor2'
      //     },
      //     'Shifting Demographics': {
      //       'fowtr-section3': 'fowtr-anchor3'
      //     },
      //     'Technology Advancements': {
      //       'fowtr-section4': 'fowtr-anchor4'
      //     },
      //     'COVID19 Pandemic': {
      //       'fowtr-section5': 'fowtr-anchor5'
      //     },
      //   };
      // }
      // if(chapter==2){
      //   scenes = {
      //     'Introduction': {
      //       'fowtr-section1': 'fowtr-anchor1'
      //     },
      //     'Macroforces': {
      //       'fowtr-section2': 'fowtr-anchor2'
      //     },
      //     // 'Shifting Demographics': {
      //     //   'fowtr-section3': 'fowtr-anchor3'
      //     // },
      //     // 'Technology Advancements': {
      //     //   'fowtr-section4': 'fowtr-anchor4'
      //     // },
      //     // 'COVID19 Pandemic': {
      //     //   'fowtr-section5': 'fowtr-anchor5'
      //     // },
      //   };
      // }

      // var pillNavContainer = $('#fowtr-pill-nav');
      // var mainNavContainer = $('#fowtr-navigation-menu');
      // //clear out first
      // pillNavContainer.html('');
      // mainNavContainer.html('');

      // for(var key in scenes) {
      //   // skip loop if the property is from prototype
      //   if (!scenes.hasOwnProperty(key)) continue;

      //   var obj = scenes[key];

      //   for (var prop in obj) {
      //     // skip loop if the property is from prototype
      //     if(!obj.hasOwnProperty(prop)) continue;


      //     //add the pill to the nav
      //     var pill = $('<a href="#'+prop+'" class="'+obj[prop]+'"><span>'+key+'</span></a>');
      //     pill.appendTo(pillNavContainer);
      //     pill.clone().appendTo(mainNavContainer);

      //     console.log('trigger','#' + prop);// e.g. #fowtr-article1
      //     console.log('anchor','.' + obj[prop]);//e.g. .fowtr-anchor1
      //     console.log('height','' + $('#' + prop).height());

      //     // new ScrollMagic.Scene({ triggerElement: '#' + prop, duration: '100%', triggerHook: 'onCenter'})
      //     new ScrollMagic.Scene({ triggerElement: '#' + prop, duration: $('#' + prop).height(), triggerHook: 'onCenter'})
      //         .setClassToggle('.' + obj[prop], 'active')
      //         // .addIndicators()
      //         // .on("progress", function (e) {
      //         //   var pillHeight = 17;
      //         //   var progress = (e.progress.toFixed(2) * pillHeight);
      //         //   // console.log(e.progress.toFixed(3));
      //         //   console.log('.' + obj[prop] + ' div');
      //         //   // $('.' + obj[prop] + ' div').hide();
      //         //   $('#fowtr-wrapper #fowtr-pill-nav a.active div').css({top:progress});
      //         // })
      //         .addTo(fowtr_module_scrollmagic.controller);
      //   }
      // }












      // // Change behaviour of controller
      // // to animate scroll instead of jump
      // controller.scrollTo(function(target) {

      //   TweenMax.to(window, 0.5, {
      //     scrollTo : {
      //       y : target,
      //       autoKill : true // Allow scroll position to change outside itself
      //     },
      //     ease : Cubic.easeInOut
      //   });

      // });


      // //  Bind scroll to anchor links using Vanilla JavaScript
      // var anchor_nav = document.querySelector('.anchor-nav');

      // anchor_nav.addEventListener('click', function(e) {
      //   var target = e.target,
      //       id     = target.getAttribute('href');

      //   if(id !== null) {
      //     if(id.length > 0) {
      //       e.preventDefault();
      //       controller.scrollTo(id);

      //       if(window.history && window.history.pushState) {
      //         history.pushState("", document.title, id);
      //       }
      //     }
      //   }
      // });















    };

    return fowtr_module_navigation;
}(fowtr_module_navigation || {}));
